/*
 * Parlay lens-swap controller
 * -------------------------------------------------------------
 * Makes the whole PDP lens-aware. Every section renders BOTH a Day and a Dusk
 * version of its content, tagged:
 *     <div data-lens="day"> ...Everyday copy/images... </div>
 *     <div data-lens="dusk"> ...Dusk copy/images... </div>
 * This controller flips which set is visible the instant the selected LENS
 * variant changes — no page reload. Color changes are ignored (they only affect
 * the gallery, which the theme swaps on its own via the gang_media metafield).
 *
 * Visibility itself is handled in CSS (parlay-lens-swap.css) off a single root
 * attribute: <html data-active-lens="day|dusk">. This controller only sets that
 * attribute. Set it server-side on first paint (from the initial variant) to
 * avoid a flash — see the wiring snippet in the PDP section.
 */
(function () {
  'use strict';

  var ROOT = document.documentElement;

  // Map a Lens option VALUE to 'day' | 'dusk' (position-independent, by value).
  function lensKind(value) {
    if (!value) return null;
    var v = String(value).toLowerCase();
    if (v.indexOf('dusk') > -1 || v.indexOf('night') > -1 || v.indexOf('evening') > -1) return 'dusk';
    if (v.indexOf('everyday') > -1 || v === 'day' || v.indexOf('day') > -1) return 'day';
    return null;
  }

  // Pull the lens out of a Shopify variant object (options array or option1/2/3).
  function lensFromVariant(variant) {
    if (!variant) return null;
    var opts = variant.options;
    if (!opts || !opts.length) {
      opts = [variant.option1, variant.option2, variant.option3];
    }
    var kind = null;
    for (var i = 0; i < opts.length; i++) {
      var k = lensKind(opts[i]);
      if (k) kind = k; // last matching option wins; only Lens values ever match
    }
    return kind;
  }

  function setLens(kind) {
    if (!kind) return; // color-only change → leave the lens content alone
    if (ROOT.getAttribute('data-active-lens') === kind) return;
    ROOT.setAttribute('data-active-lens', kind);
    // let other scripts react (e.g. a sticky bar or analytics)
    document.dispatchEvent(new CustomEvent('parlay:lens', { detail: { lens: kind } }));
  }

  function handleVariant(variant) {
    setLens(lensFromVariant(variant));
  }

  // 1) Preferred: the theme's pub/sub bus (fires on every variant change).
  function subscribePubsub() {
    try {
      if (window.theme && theme.pubsub && theme.pubsub.subscribe && theme.pubsub.PUB_SUB_EVENTS) {
        theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, function (payload) {
          var variant = payload && payload.data && payload.data.variant;
          handleVariant(variant);
        });
        return true;
      }
    } catch (e) {}
    return false;
  }

  // 2) Belt-and-suspenders: the DOM CustomEvent (dispatched on the product form
  //    or document; not guaranteed to bubble, so listen in the capture phase).
  document.addEventListener('variant:change', function (e) {
    var variant = e.detail && e.detail.variant;
    handleVariant(variant);
  }, true);

  // 3) Initial state — if the server didn't stamp data-active-lens, try to infer
  //    it from a checked lens control, else default to Day (matches CSS default).
  function initInitial() {
    if (ROOT.getAttribute('data-active-lens')) return; // server already set it
    var checked = document.querySelector(
      'input[type="radio"][name*="Lens" i]:checked, input[type="radio"][name*="lens" i]:checked'
    );
    var kind = checked && (lensKind(checked.value) || lensKind(checked.getAttribute('data-value')));
    setLens(kind || 'day');
  }

  function boot() {
    // retry pubsub a few times in case theme.js loads after us
    if (!subscribePubsub()) {
      var tries = 0;
      var t = setInterval(function () {
        tries++;
        if (subscribePubsub() || tries > 20) clearInterval(t);
      }, 150);
    }
    initInitial();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
